var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80479 0.897073C10.2448 0.273979 10.854 -0.00679842 11.5002 0.000124857C12.1133 0.00627888 12.7102 0.268594 13.2087 0.617835C13.7171 0.975783 14.1507 1.4297 14.4849 1.95403C14.8003 2.45327 15.028 3.04329 14.9972 3.61946C14.8488 6.39108 13.2895 9.3527 11.0994 11.5443C8.91093 13.7336 5.98855 15.2552 3.03772 14.9644C2.45925 14.9075 1.91231 14.6128 1.46538 14.2375C1.00311 13.8459 0.625431 13.3643 0.355354 12.822C0.0938101 12.2897 -0.0623474 11.6758 0.0238085 11.0781C0.113041 10.455 0.461511 9.8981 1.10229 9.52886C1.23505 9.45183 1.36636 9.37233 1.49615 9.29039C1.61154 9.21885 1.73461 9.14115 1.88385 9.05192C2.18866 8.86398 2.51032 8.70483 2.84464 8.57652C3.18849 8.45113 3.58158 8.36882 3.99082 8.42498C4.41467 8.48344 4.80853 8.68345 5.14931 9.04192C5.41162 9.31885 5.79778 9.40501 6.34087 9.24808C6.89319 9.08808 7.51474 8.69114 8.05475 8.1542C8.59477 7.6188 9.00324 6.99263 9.17786 6.42723C9.35017 5.86721 9.27401 5.45566 9.00478 5.17181C8.64092 4.78872 8.44707 4.36256 8.4063 3.91177C8.3663 3.4733 8.47553 3.06098 8.63169 2.70097C8.86554 2.16326 9.26247 1.62863 9.57325 1.2117C9.65139 1.10746 9.72832 1.00232 9.80402 0.896304",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneIcon);
export default __webpack_public_path__ + "static/media/telephone-icon.b3df9fc2edf3c21e694e06c83a82ffdc.svg";
export { ForwardRef as ReactComponent };